import axios from 'axios'
import pako from 'pako'

const language = localStorage?.getItem('language') || 'zh-CN'
// 解压并解析 JSON 文件的方法
export function fetchAndDecompressJson(url, from) {
  return new Promise((resolve, reject) => {
    const langName = getUrlConcatName(url)
    // 获取压缩文件的二进制数据
    axios
      .get(url, {
        responseType: 'arraybuffer', // 获取二进制数据
        timeout: 60000,
      })
      .then((response) => {
        let langJson = undefined
        try {
          // 解压数据
          const compressedData = new Uint8Array(response.data)
          //缓存语言包
          saveArrayBuffer(langName, compressedData)
          // 解析并返回 JSON 对象
          langJson = decodeLangData(compressedData, from)
        } catch (error) {
          console.error('解压文件或解析 JSON 失败', error)
          //定位问题
          const langCache = localStorage?.getItem(langName)
          if (langCache) {
            try {
              const loadedBuffer = loadArrayBuffer(langName)
              const compressedData = new Uint8Array(loadedBuffer)
              langJson = decodeLangData(compressedData, from)
            } catch (error) {
              console.error('加载缓存失败', error)
              reject(error)
            }
          } else {
            reject(error)
          }
        }
        resolve(langJson)
      })
      .catch((error) => {
        console.error('请求json文件失败', error)
        const langCache = localStorage?.getItem(langName)
        if (langCache) {
          try {
            const loadedBuffer = loadArrayBuffer(langName)
            const compressedData = new Uint8Array(loadedBuffer)
            const cacheLang = decodeLangData(compressedData, from)
            resolve(cacheLang)
          } catch (error) {
            console.error('加载缓存失败', error)
            reject(error)
          }
        } else {
          reject(error)
        }
      })
  })
}

function decodeLangData(compressedData, from) {
  let json = undefined
  const decompressedData = pako.inflate(compressedData)
  if (from === 'iswww') {
    json = Buffer.from(decompressedData)
      .toString('utf-8')
      .replace(/^\uFEFF/, '')
      .trim()
  } else {
    // 将解压后的数据转为 JSON 字符串
    json = new TextDecoder().decode(decompressedData)
    // 解析并返回 JSON 对象
  }
  // 将解压后的数据转为 JSON 字符串
  return json ? JSON.parse(json) : {}
}

function getUrlConcatName(url) {
  // 使用正则提取路径部分（兼容查询参数和哈希）
  const pathMatch = url.match(/\/[^?#]*/)
  if (!pathMatch) throw new Error('Invalid URL')

  // 分割路径并过滤空段
  const segments = pathMatch[0].split('/').filter((seg) => seg)

  // 处理每个段的小写转换
  const processed = segments.map((seg) => seg.toLowerCase())

  // 处理文件扩展名（仅最后一个段）
  const lastSegment = processed[processed.length - 1]
  const isFile = lastSegment.includes('.')

  if (isFile) {
    // 处理多级扩展名（如 .tar.gz → .tar）
    const baseName = lastSegment.replace(/\.[^.]+$/, '')
    processed[processed.length - 1] = baseName
  }

  // 拼接所有段
  return processed.join('-')
}
function saveArrayBuffer(key, arrayBuffer) {
  // 将 ArrayBuffer 转换为 Uint8Array
  const uint8Array = new Uint8Array(arrayBuffer)

  // 将 Uint8Array 转换为 Base64 字符串
  let binary = ''
  uint8Array.forEach((byte) => (binary += String.fromCharCode(byte)))
  const base64String = btoa(binary)

  // 存储到 localStorage
  localStorage.setItem(key, base64String)
}
function loadArrayBuffer(key) {
  // 从 localStorage 获取 Base64 字符串
  const base64String = localStorage.getItem(key)
  if (!base64String) return null

  // 将 Base64 转换为二进制字符串
  const binaryString = atob(base64String)

  // 创建 Uint8Array 并填充数据
  const bytes = new Uint8Array(binaryString.length)
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i)
  }

  // 转换为 ArrayBuffer
  return bytes.buffer
}



// WEBPACK FOOTER //
// ../@ost/lib/common/lang.js